// extracted by mini-css-extract-plugin
export default {"fields":"product-description-modal_fields__QDkol","actions":"product-description-modal_actions__nnVHc","noSelectInput":"product-description-modal_noSelectInput__zTumO"};